// src/oura/components/newscan/wordFocus.ts
//
// "Type one" and "Built from" links land on a word's field in the Words view
// (local) or the Searches view (brand).

/**
 * Brings a word's row into view and puts the caret in its field, as soon as
 * the row is rendered (checked every frame, for up to about half a second).
 * Focus moves first and the scroll follows, so keys typed straight after
 * "Type one" land in the word asked for, never in the one just left.
 * Returns the cleanup.
 */
export function focusWordField(scope: HTMLElement | null, variable: string, reduced: boolean, done: () => void): () => void {
    let frame = 0;
    let tries = 0;
    const attempt = () => {
        const row = (scope ?? document).querySelector<HTMLElement>(`[data-word-row="${CSS.escape(variable)}"]`);
        const input = row?.querySelector<HTMLInputElement>("input:not([disabled])");
        if (row && input) {
            input.focus({ preventScroll: true });
            row.scrollIntoView({ block: "center", behavior: reduced ? "auto" : "smooth" });
            done();
            return;
        }
        if (row && !row.querySelector("input")) {
            // A word set on the Business step: no field, so show the row and stop.
            row.scrollIntoView({ block: "center", behavior: reduced ? "auto" : "smooth" });
            done();
            return;
        }
        tries += 1;
        if (tries > 30) {
            done();
            return;
        }
        frame = requestAnimationFrame(attempt);
    };
    attempt();
    return () => cancelAnimationFrame(frame);
}
